import { createAction } from '@reduxjs/toolkit';
export const TOGGLE_EDIT_QUOTE = 'TOGGLE_EDIT_QUOTE';
export const toggleEditQuote = createAction<any>(TOGGLE_EDIT_QUOTE);
